export const rolesChoices = [
    { id: 'admin', name: 'Administrador' },
    { id: 'coordinador', name: 'Coordinador Interno' },
    { id: 'externo', name: 'Coordinador Externo' },
    // { id: 'coordinado', name: 'Coordinado' },
]

export const booleanChoice = [
  { id: true, name: 'Activado' },
  { id: false, name: 'Desactivado' }
]
